import { Countries } from '../interfaces/countries.interface'

export const SET_COUNTRIES       = '[COUNTRIES] Set'

import { createAction, props } from '@ngrx/store';

export const setCountries = createAction( SET_COUNTRIES , props<{countries: Countries[]}>());
